<template>
    <div class="cols">
    <div class="overflow-wrapper">
        <div class="cols margin-bottom-20" style="gap: 10px;">
            <button @click="edit(-1)">Nový záznam</button>
            <button @click="exportTable">Export</button>
        </div>

        <div style="display: flex; align-items: flex-start;">
            <EditUzivatel
                v-if="showEdit"
                :itemId="itemId"
                @close="closeEdit"
                @updateTable="updateTable"
                class="margin-bottom-20 border padding-10"
            />
        </div>

        <div class="overflow-container">
            <div>
                <table>
                    <thead>
                        <tr>
                            <th v-for="(v, k) in headers" :key="k" @click="sort(k)">{{ v }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in sortedRows" :key="i" @click="edit(row['id'])">
                            <td
                                v-for="(header, j) in headerKeys"
                                :key="j"
                            >
                                {{ row[header] }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div>
        <img alt="matice" src="@/assets/img/matice.png">
    </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'
    import EditUzivatel from './EditUzivatel.vue'

    export default {
        name: 'Uzivatel',
        components: {
            EditUzivatel
        },
        data() {
            return {
                headers: {},
                rows: [],
                currentSort: '',
                currentSortDir: 'asc',
                showEdit: false,
                itemId: -1
            }
        },
        computed: {
            headerKeys() {
                return Object.keys(this.headers)
            },
            sortedRows() {
                if (this.currentSort === '')
                    return this.rows
                return this.rows.slice().sort(
                    (a, b) => this.currentSortDir === 'desc' 
                        ? b[this.currentSort].localeCompare(a[this.currentSort], 'cz') 
                        : a[this.currentSort].localeCompare(b[this.currentSort], 'cz'))
            }
        },
        methods: {
            updateTable() {
                this.headers = { "prijmeni": "Příjmení", "jmeno": "Jméno", "email": "E-mail", "role": "Role" }
                this.$progress.start()
                api.getUzivatel()
                .then(response => {
                    this.$progress.finish()
                    this.rows = response.data
                })
                .catch(error => {
                    this.$progress.finish()
                    console.log('Error: ', error)
                })
            },
            sort(s) {
                if (s === this.currentSort) {
                    this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
                }
                else {
                    this.currentSort = s
                    this.currentSortDir = 'asc'
                }
            },
            edit(id) {
                this.itemId = id
                this.showEdit = true
            },
            closeEdit() {
                this.showEdit = false
                this.itemId = -1
            },
            exportTable() {
                window.open(process.env.VUE_APP_API_URL + '/export/uzivatel')
            }
        },
        created() {
            this.showEdit = false
            this.updateTable()
        }
    }
</script>